export enum TooltipMode {
    Hover = 'hover',
    Sticky = 'sticky',
    Inert = 'inert',
}

export enum TooltipEventKind {
    PointerEnter = 'pointerEnter',
    PointerMove = 'pointerMove',
    PointerLeave = 'pointerLeave',
    PointerDown = 'pointerDown',
    PointerUp = 'pointerUp',
    Focus = 'focus',
    Blur = 'blur',
    Click = 'click',
    TimerFired = 'timerFired',
    HoverCheck = 'hoverCheck',
    OutsideClose = 'outsideClose',
    ContentRemoved = 'contentRemoved',
    ModeChanged = 'modeChanged',
}

export type PlainTooltipEventKind = Exclude<TooltipEventKind, TooltipEventKind.PointerMove>;

export type TooltipEvent =
    | { kind: TooltipEventKind.PointerMove; isTouch: boolean } |
    { kind: PlainTooltipEventKind };

export interface TooltipInput {
    mode: TooltipMode;
    isHoveredOrFocused: () => boolean;
    isOpenDelayed: boolean;
}

export interface TooltipState {
    isOpen: boolean;
    isShown: boolean;
    isPointerDown: boolean;
    hasPointerMoveOpened: boolean;
    isTimerRunning: boolean;
}

export interface TooltipWindow {
    isOpenDelayed: (now: number) => boolean;
    markOpen: (tooltipId: string, closeTooltip: () => void) => void;
    markClosed: (tooltipId: string, now: number) => void;
}

export interface TooltipSettings {
    delayMs: number;
    window: TooltipWindow;
}
